<!-- <body> -->

     <!-- <div class="main_content" [ngClass]="{ 'collapsed': isCollapsed }">
          <app-sidebar class="sideBar"></app-sidebar>
     </div> -->

     <!-- <app-grievance-user1 *ngIf="activeView === 'grievance'" [style.width]="containerWidth"
          [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-grievance-user1>

     <app-ticket-details *ngIf="activeView === 'trackDetails'" [style.width]="containerWidth"
          [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-ticket-details> -->

     <!-- <app-grievance-report *ngIf="activeView === 'report'" [style.width]="containerWidth"
          [ngClass]="{ 'collapsed': isContainerCollapsed }">
     </app-grievance-report> -->

     <!-- GRIEVANCE_USER2  -->
     <!-- <app-grievanceuser2-dashboard *ngIf="activeView === 'grievanceuser2'" [style.width]="containerWidth"
          [ngClass]="{ 'collapsed': isContainerCollapsed }">
     </app-grievanceuser2-dashboard> -->

     <!-- <app-ticket-details-user2 *ngIf="activeView === 'trackDetailsuser2'" [style.width]="containerWidth"
          [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-ticket-details-user2> -->

     <!--END GRIEVANCE_USER2 -->

     <!--GRIEVANCE_Admin -->
<!--      
     <app-grievance-admin *ngIf="activeView === 'grievanceAdmin'" [style.width]="containerWidth"
          [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-grievance-admin>

     <app-ticket-admin *ngIf="activeView === 'trackDetailsAdmin'" [style.width]="containerWidth"
          [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-ticket-admin> -->

     <!-- End GRIEVANCE_Admin -->

     <!--GRIEVANCE_AdminSuper -->
<!-- 
     <app-grievance-super-admin *ngIf="activeView === 'grievanceSuperadmin'" [style.width]="containerWidth"
          [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-grievance-super-admin>

      <app-ticket-super-admin *ngIf="activeView === 'trackDetailsSuperadmin'" [style.width]="containerWidth"
          [ngClass]="{ 'collapsed': isContainerCollapsed }"></app-ticket-super-admin>   -->

     <!-- End GRIEVANCE_Admin -->


<!-- </body> -->


<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
     <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>